import type React from 'react';
import type { AppSsrFetchedDataType } from '../../../server/AppSsr';
import MainLayout from '../../layout/MainLayout/MainLayout';
import WelcomeBody from './WelcomeBody';

interface WelcomeProps {
  ssrFetchedData: AppSsrFetchedDataType;
}

const Welcome: React.FC<WelcomeProps> = ({ ssrFetchedData }) => (
  <MainLayout
    customSize={2000}
    categories={false}
    search
    navbar
    footer
    ssrFetchedData={ssrFetchedData}
  >
    <WelcomeBody />
  </MainLayout>
);

export default Welcome;
